module.exports = __webpack_public_path__ + "img/9788991239753.1ed7f643.jpg";